// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"00e696f7","577":"3b4cbe7b","641":"17121d9f","675":"23ac8563","676":"a23ccb36","747":"e8cec659","795":"17e3b18c","876":"86919f1d","896":"e0b385e0","916":"4dfb007d","977":"a93d37e7"}[chunkId] + ".chunk.js";
};